"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Notice = _interopRequireDefault(require("./Notice"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const translate = {
  es: {
    ERROR_TITLE: 'Información no disponible',
    ERROR_DESCRIPTION: 'Hubo un problema al intentar obtener la información.'
  }
};
function NoticeUnavailable() {
  return /*#__PURE__*/_react.default.createElement(_Notice.default, {
    name: "fas fa-exclamation-circle",
    title: translate['es'].ERROR_TITLE,
    description: translate['es'].ERROR_DESCRIPTION
  });
}
var _default = exports.default = NoticeUnavailable;